import { useMutation, useQueryClient } from '@tanstack/react-query';

import { assignUserRoles, createRole, deleteRole, updateRole } from '../../../api/roles';
import type { RoleCreatePayload, RoleUpdatePayload } from '../../../types/roles';
import { useAuth } from '../../auth/AuthProvider';

export function useCreateRole() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: RoleCreatePayload) => createRole(payload, tokens!.access_token),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['roles'] }),
  });
}

export function useUpdateRole() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ roleId, payload }: { roleId: string; payload: RoleUpdatePayload }) =>
      updateRole(roleId, payload, tokens!.access_token),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['roles'] }),
  });
}

export function useDeleteRole() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (roleId: string) => deleteRole(roleId, tokens!.access_token),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['roles'] }),
  });
}

export function useAssignUserRoles() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, roleIds }: { userId: string; roleIds: readonly string[] }) =>
      assignUserRoles(userId, { role_ids: roleIds }, tokens!.access_token),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['users'] }),
  });
}
